import { createI18n } from 'vue-i18n'
import zhCN from './zh-cn.json'
import zhHant from './zh-hant.json'
import en from './en.json'
import ja from './ja.json'
import ko from './ko.json'
import { GuessUserLangCode } from '@/locales/langcode'

const getSystemLanguage = () => {
  const code = localStorage.getItem('i18n-language') || navigator.language.toLowerCase()
  let urlParams = new URLSearchParams(window.location.search.slice(1))
  let co = urlParams.get('app-language')
  if (co) {
    return GuessUserLangCode(co)
  }
  return GuessUserLangCode(code)
}

const normalizeClientLang = rawLang => {
  if (!rawLang) return 'zh'

  const langType = String(rawLang).toLowerCase()

  if (langType === 'en') return 'en'
  if (langType === 'zh' || langType === 'zh-cn' || langType === 'zhcn') return 'zh'
  if (langType === 'zh-tw' || langType === 'zh-hant') return 'hant'

  if (langType.startsWith('zh-') || langType.startsWith('zh_') || langType.startsWith('zh')) {
    if (langType.includes('tw') || langType.includes('hant')) return 'hant'
    return 'zh'
  }

  return langType || 'zh'
}

const i18n = createI18n({
  locale: getSystemLanguage(),
  fallbackLocale: 'zhCN',
  legacy: false,
  globalInjection: true,
  messages: {
    zhCN,
    zhHant,
    en,
    ja,
    ko,
  },
})

export { i18n, getSystemLanguage, normalizeClientLang }
